var blogpages = [
	'the-latest',
	'videos',
	'listen',
	'read'
];

function blogpage_init() {
	var qp = getQueryParams();
	// console.log( `qp`, qp );
	// validate page url param
	var blogpage_valid = false;
	if(qp.hasOwnProperty('p')) {
		// console.log( `qp.p`, qp.p );
		// console.log( `blogpages`, blogpages );
		// console.log( `blogpages.indexOf(qp.p)`, blogpages.indexOf(qp.p) );
		blogpage_valid = blogpagevalidate(qp.p);
	}
	// render page + nav
	blogpagerender(qp.p);
	// search
	// ...
}

// **************************************************************** //

function blogpagevalidate(page) {
	var response = false;
	// if page is not null/false
	if(page) {
		// if page exists in `blogpages` array
		if(blogpages.indexOf(page) > -1) {
			// if blogpage section exists
			if($('.bp--' + page).length > 0) {
				response = true;
			}
		}
	}
	return response;
}

// **************************************************************** //

function blogpagelink(page, e) {
	e.preventDefault();
	window.scrollTo(0, 0);
	blogpage(page);
}

// **************************************************************** //

function blogpagenav(page) {
	// console.log( `blogpagenav(page)`, page );
	// if blogpage nav exists
	var blogpage_valid = false;
	if($('.bpn--' + page).length > 0) {
		// validate page
		blogpage_valid = blogpagevalidate(page);
	}
	// render nav
	$('.sights-sounds-header-nav-link').removeClass('active');
	if(blogpage_valid) {
		// render nav: blogpage
		$('.bpn--' + page).addClass('active');
		console.log( 'NAV: BLOGPAGE: ' + page );
	}
	else {
		console.log( 'NAV: HOMEPAGE' );
	}
}

// **************************************************************** //

function blogpagerender(page) {
	// validate page
	var blogpage_valid = blogpagevalidate(page);
	// close all blogpages
	$('.bp').removeClass('active');
	// render page + nav
	if(blogpage_valid) {
		// activate blogpage
		$('.bp--' + page).addClass('active');
		console.log( 'RENDER: BLOGPAGE: ' + page );
		// nav
		blogpagenav(page);
	}
	else {
		// activate homepage
		$('.bp--sights-sounds').addClass('active');
		console.log( 'RENDER: HOMEPAGE' );
		// nav
		blogpagenav(null);
	}
}

// **************************************************************** //

function blogpage(page) {
	// console.log( `blogpage(page)`, page );
	// validate page
	var blogpage_valid = blogpagevalidate(page);
	// render page + nav
	blogpagerender(page);
	// history state
	var url = new URL(window.location);
	if(blogpage_valid) {
		// history state: blogpage
		url.searchParams.set('p', page);
	}
	else {
		// history state: homepage
		url.searchParams.delete('p');
	}
	window.history.pushState({}, '', url);
}

// **************************************************************** //

window.addEventListener('popstate', function(event) {
	console.log( `addEventListener: popstate` );
	console.log( `document.location`, document.location );
	console.log( `event.state`, event.state );
	var qp = getQueryParams(document.location.search);
	console.log( `qp`, qp );
	// validate page url param
	var blogpage_valid = false;
	if(qp.hasOwnProperty('p')) {
		// console.log( `qp.p`, qp.p );
		// console.log( `blogpages`, blogpages );
		// console.log( `blogpages.indexOf(qp.p)`, blogpages.indexOf(qp.p) );
		blogpage_valid = blogpagevalidate(qp.p);
	}
	// render page + nav
	blogpagerender(qp.p);
})

$(document).ready(function() {
$('.bp--sights-sounds').addClass('active');	
});
